import axios, { AxiosRequestConfig } from 'axios';
// Studio's web client uses /api/studio/v1. AI admin routes belong to that
// backend's /api root; keep the same configured origin and auth interceptors.
const url = (path: string) => `${String(axios.defaults.baseURL || '/api').replace(/\/studio\/v1\/?$/, '').replace(/\/$/, '')}${path}`;
const adminAiApi = {
  get: (path: string, config?: AxiosRequestConfig) => axios.get(url(path), config),
  post: (path: string, body?: unknown) => axios.post(url(path), body),
  delete: (path: string) => axios.delete(url(path)),
};
export default adminAiApi;
